// extracted by mini-css-extract-plugin
export var listBlock = "TrrJ2";
export var listBlockItem = "J9SSb";
export var listBlockItemParagraph = "hDfRO";